import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupWindowStaticTitle from "../components/PiPopupWindowStaticTitle";
import SetCharacterPartsPreviewBody from "./SetCharacterPartsPreviewBody";

export default function SetCharacterPartsPreview() {
  return (
    <PiPopupWindowPreview
      title={<PiPopupWindowStaticTitle title="Set Character Parts" />}
      body={<SetCharacterPartsPreviewBody />}
      size="large"
    />
  );
}
